<div class="deletion-form">
  <div class="main-txt">
      Do You want to delete your associated Facebook Account Data?
  </div>
  <div class="secondary-txt">
    If you want to delete all your facebook Data click on submit or you can <span class="app-btn" (click)="navigateToBusinessDashboard()">go back to the app</span> if you don't want to delete the data
    <br>All related Facebook data to {{dataDeletionForm.value.userEmail}} will be deleted
  </div>
    <form [formGroup]="dataDeletionForm" (ngSubmit)="submitRequest.emit(dataDeletionForm.value)">
      <div class="position-relative form-group">
        <input 
          formControlName="userId" 
          name="userId" id="userId" 
          type="hidden" class="form-control">
      </div>
      <div class="position-relative form-group">
        <input 
          formControlName="userEmail" 
          name="userEmail" id="userEmail" 
          type="hidden" class="form-control">
      </div>
      <button class="btn submit-btn" type="submit" [disabled]="!dataDeletionForm.valid">Submit</button>
    </form>
</div>
